import React from 'react';

const JS_RegExp_Patterns = () => {
  return (
    <div >
      <h1>JS_RegExp_Patterns</h1>
      <p>Placeholder component for: "JS RegExp Patterns"</p>
    </div>
  );
};

export default JS_RegExp_Patterns;
